import { Text } from "@clipboard-health/ui-react";
import { Alert, Link, Stack } from "@mui/material";
import { type ReactElement } from "react";

interface ResetEmailSentConfirmationProps {
  email: string;
  onBackToLogin: () => void;
}

export function ResetEmailSentConfirmation({
  email,
  onBackToLogin,
}: ResetEmailSentConfirmationProps): ReactElement {
  return (
    <Stack spacing={2.5}>
      <Text align="center" variant="h4">
        Check your email
      </Text>
      <Alert severity="success" sx={{ textAlign: "left" }}>
        A password reset link has been sent to <strong>{email}</strong>. Please check your email and
        click the link to set a new password.
      </Alert>
      <Text align="center" color="text.secondary" variant="body1">
        The link expires in 1 hour. If you do not see the email, check your spam folder.
      </Text>
      <Link
        component="button"
        sx={{ alignSelf: "center" }}
        type="button"
        underline="hover"
        variant="body2"
        onClick={onBackToLogin}
      >
        Back to sign in
      </Link>
    </Stack>
  );
}
